import Link from "next/link";

import type { SwitchingStep } from "@/content/comparisons/schema";

interface SwitchingStepsProps {
  heading: string;
  description: string;
  steps: SwitchingStep[];
  competitorName: string;
}

export function SwitchingSteps({ heading, description, steps, competitorName }: SwitchingStepsProps) {
  return (
    <section className="bg-ash-100 py-16 md:py-24">
      <div className="mx-auto max-w-4xl px-6">
        <h2 className="font-clash text-3xl font-medium leading-tight tracking-snug text-ash-900 md:text-5xl">
          {heading}
        </h2>

        <div className="mt-4">
          <Link
            href="https://cal.com/team/builtright/launch"
            className="inline-flex items-center rounded-full bg-rebolt-500 px-8 py-3.5 text-base font-semibold text-white transition-colors hover:bg-rebolt-600"
          >
            Get More Business
          </Link>
        </div>

        <p className="mt-6 text-sm font-medium text-ash-500">{description}</p>
        <p className="mt-4 text-lg font-medium text-ash-700">
          Making the switch to Rebolt from {competitorName} is straightforward. Here&apos;s how the process works:
        </p>

        <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-2">
          {steps.map((step, i) => (
            <div key={step.title} className="rounded-2xl border border-ash-200 bg-white p-6">
              <div className="mb-3 flex size-8 items-center justify-center rounded-full bg-rebolt-500 text-sm font-bold text-white">
                {i + 1}
              </div>
              <h3 className="font-clash text-lg font-medium text-ash-900">{step.title}</h3>
              <p className="mt-1 text-sm text-ash-500">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
